import { FetchTicketResponsePriority } from 'src/api/models';

export interface StatusColors {
  dot: string;
  text: string;
}

const STATUS_COLOR_MAP: Record<string, StatusColors> = {
  new: { dot: 'bg-yellow-500', text: 'text-yellow-700 dark:text-yellow-300' },
  ongoing: { dot: 'bg-blue-500', text: 'text-blue-700 dark:text-blue-300' },
  closed: { dot: 'bg-green-500', text: 'text-green-700 dark:text-green-300' },
};

const DEFAULT_STATUS_COLORS: StatusColors = {
  dot: 'bg-surface-400',
  text: 'text-surface-600 dark:text-surface-400',
};

export function getStatusColors(statusName?: string): StatusColors {
  if (!statusName) return DEFAULT_STATUS_COLORS;
  return STATUS_COLOR_MAP[statusName.toLowerCase()] ?? DEFAULT_STATUS_COLORS;
}

export interface PriorityOption {
  value: FetchTicketResponsePriority;
  label: string;
  icon: string;
  color: string;
}

export const PRIORITY_OPTIONS: PriorityOption[] = [
  { value: FetchTicketResponsePriority.lows, label: 'Low', icon: 'pi-angle-down', color: 'text-blue-500' },
  { value: FetchTicketResponsePriority.medium, label: 'Medium', icon: 'pi-minus', color: 'text-amber-500' },
  { value: FetchTicketResponsePriority.high, label: 'High', icon: 'pi-angle-double-up', color: 'text-red-500' },
];
